// Vendor
import * as React from 'react';
import { BarSvgProps, ResponsiveBar } from '@nivo/bar';
import { useInView } from 'react-intersection-observer';
import {
  SPOT_BRAND,
  SPOT_CLEANOUT_LIGHTER,
  SPOT_GREEN
} from '@thredup/styleguide/src/variables/colors';

// Internal
import { Circle } from './Circle';
import { data } from './data';
import { DEFAULT_CHART_PROPS } from '@src/config/nivo';

const ChartResaleAccelerate: React.FC = () => {
  // Hooks
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px'
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const initialData = data.map((d: any) => ({
    ...d,
    growth: 0
  }));

  const chartData = inView ? data : initialData;
  const colors = {
    'All Retail Clothing': SPOT_CLEANOUT_LIGHTER,
    'Traditional Thrift & Donation': SPOT_GREEN,
    Resale: SPOT_BRAND
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getColors = (bar: any) => (colors as any)[bar.indexValue];

  const barProps: BarSvgProps = {
    ...DEFAULT_CHART_PROPS,
    barComponent: Circle,
    colors: getColors,
    data: chartData,
    enableGridY: true,
    enableGridX: false,
    enableLabel: true,
    gridYValues: [0],
    indexBy: 'sector',
    keys: ['growth'],
    margin: { top: 50, right: 0, bottom: 40, left: 0 },
    maxValue: 420,
    minValue: -80
  };

  return (
    <span ref={ref}>
      <ResponsiveBar {...barProps} />
    </span>
  );
};

export { ChartResaleAccelerate };
